import { RepositoriesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { repositoriesKeys } from 'app/queries/repositories/repositoriesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.detail>>;

export const createFetchRepositoryQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ repositoryId }], signal }: TParams) =>
    call(() => cancelOnSignal(RepositoriesService.adminFindOne({ repositoryId }), signal));
